import ObjectModelRelation from "./objectModelRelation";
import ObjectModelEntry from "../objectModelEntries/objectModelEntry";
import Guid from "~/helpers/guid";
import BuilderModel from "~/models/tracked/builderModel";

export default class EntryRelation extends BuilderModel{
  client_id: string;
  published_relation_id: string;
  entry_id: string;
  related_entry_id: string;

  constructor(parent, nameInParent, json={}) {
    super()
    this.client_id = json['client_id']|| Guid.create();
    this.published_relation_id =  json["published_relation_id"];
    this.entry_id = json["entry_id"];
    this.related_entry_id = json["related_entry_id"];
  }

  get relation(): ObjectModelRelation {
    return ObjectModelRelation.repo.find(this.published_relation_id)
  }

  get entry(): ObjectModelEntry {
    return ObjectModelEntry.repo.find(this.entry_id)
  }

  get relatedEntry(): ObjectModelEntry {
    return ObjectModelEntry.repo.find(this.related_entry_id)
  }

  get json(): any {
    return {
      client_id: this.client_id,
      published_relation: this.published_relation_id,
      entry: this.entry_id, 
      related_entry: this.related_entry_id
    }
  }
}

